export enum FinanceDirection {
  INCOME = 1,
  EXPENSE = 2,
}

export enum FinanceSource {
  ISRACARD = 1,
  CAL = 2,
  MIZRAHI = 3,
  PAYPAL = 4,
  COINPAYMENTS = 5,
  AFFILIATION = 6,
  APPLE = 7,
  GOOGLE = 8,
  WHOP = 9,
  MANUAL = 10,
  EXCHANGE = 11,
}

export enum FinanceCategory {
  PAYMENT_FEES = 1,
  AFFILIATION = 2,
  BANK_FEES = 3,
  CONVERSION_FEES = 4,
  CLOUD = 5,
  SALARIES = 6,
  BANK_TRANSFERS = 7,
  CARD_EXPENSES = 8,
  SOFTWARE = 9,
  MARKETING = 10,
  TAXES = 11,
  OTHER = 12,
  INTERNAL_TRANSFER = 13,
  PROFESSIONAL_SERVICES = 14,
  SUBSCRIPTIONS = 20,
  EXCHANGE_COMMISSION = 21,
  REFUNDS = 22,
}

export enum FinanceCurrency {
  USD = "USD",
  ILS = "ILS",
}

export enum FinanceGranularity {
  MONTH = "month",
  DAY = "day",
}

export interface FinanceDateRange {
  start_date: string;
  end_date: string;
}

export interface FinanceSummaryRow {
  period: string;
  direction: FinanceDirection;
  source: FinanceSource;
  category: FinanceCategory;
  total: number;
  exchange?: string | null;
}

export interface FinanceEntry {
  id: number;
  direction: FinanceDirection;
  source: FinanceSource;
  category: FinanceCategory;
  date: string;
  amount: number;
  currency: string;
  amount_usd: number;
  amount_ils: number;
  description: string;
  is_category_locked: boolean;
}

export interface FinanceRule {
  id: number;
  pattern: string;
  category: FinanceCategory;
  source: FinanceSource | null;
}

export interface GetFinanceSummaryRequest extends FinanceDateRange {
  currency: FinanceCurrency;
  granularity?: FinanceGranularity;
}

export interface GetFinanceEntriesRequest extends FinanceDateRange {
  direction?: FinanceDirection;
  source?: FinanceSource;
  category?: FinanceCategory;
  search?: string;
  exchange?: string;
  limit?: number;
}

export interface UploadFinanceStatementRequest {
  source: FinanceSource;
  currency: FinanceCurrency;
  file: File;
}

export interface UploadFinanceStatementResponse {
  saved_count: number;
}

export interface CreateFinanceEntryRequest {
  direction: FinanceDirection;
  category: FinanceCategory;
  date: string;
  amount: number;
  currency: FinanceCurrency;
  description: string;
}

export interface UpdateFinanceEntryCategoryRequest {
  entry_id: number;
  category: FinanceCategory;
}

export interface DeleteFinanceEntryRequest {
  entry_id: number;
}

export interface CreateFinanceRuleRequest {
  pattern: string;
  category: FinanceCategory;
  source?: FinanceSource | null;
}

export interface DeleteFinanceRuleRequest {
  rule_id: number;
}

export interface FinanceRecategorizeResponse {
  recategorized_count: number;
}

export interface FinanceEntriesFilter {
  direction?: FinanceDirection;
  source?: FinanceSource;
  category?: FinanceCategory;
  exchange?: string;
}
